<section class="wraper-sub">
  <div class="lead-m">
    <div class="top-page-m">
      <div class="top-section">
        <h1 class="page-name">New Orders</h1>
        <div class="topCtaWrap">
            <a href="javascript:;" class="ctaSingle" data-toggle="modal" data-target="#sendEmailModal" *ngIf="!sendingEmail">
                <svg width="22" height="15" viewBox="0 0 22 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M20.8717 0H1.12823C0.507675 0 0 0.507675 0 1.12819V13.5384C0 14.1589 0.507675 14.6667 1.12823 14.6667H20.8718C21.4922 14.6667 22 14.159 22 13.5384V1.12819C22 0.507675 21.4923 0 20.8717 0ZM20.4484 0.846096L11.649 7.44617C11.4908 7.56657 11.2479 7.64189 10.9999 7.64077C10.752 7.64189 10.5092 7.56657 10.3509 7.44617L1.55156 0.846096H20.4484ZM15.748 7.88166L20.5429 13.8048C20.5477 13.8107 20.5536 13.8152 20.5587 13.8206H1.44126C1.44633 13.8149 1.45226 13.8107 1.45707 13.8048L6.25194 7.88166C6.39885 7.70003 6.37101 7.43375 6.18903 7.2865C6.00741 7.13959 5.74113 7.16743 5.59418 7.3491L0.846139 13.2144V1.37495L9.84352 8.12301C10.1817 8.37489 10.5932 8.48575 10.9999 8.48687C11.406 8.48601 11.8178 8.37515 12.1563 8.12301L21.1536 1.37495V13.2143L16.4057 7.3491C16.2588 7.16747 15.9923 7.13954 15.8109 7.2865C15.629 7.43341 15.601 7.70003 15.748 7.88166Z" fill="#075595"/>
                </svg>
                 <span>Send email to writers</span>
             </a>

             <i class="fa fa-spinner fa-spin" *ngIf="sendingEmail"></i>
        </div>
      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" [(ngModel)]="searchParams.order_Id_Email_Phone" (change)="rerender()" placeholder="Search by Order ID, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (change)="rerender()" (click)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}" >
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#1C212D"/>
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D"/>
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D"/>
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D"/>
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D"/>
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D"/>
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D"/>
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D"/>
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D"/>
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D"/>
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D"/>
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D"/>
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D"/>
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D"/>
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="status"
                bindLabel="name"
                bindValue="value"
                placeholder="Order Status"
                [(ngModel)]="searchParams.status"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                (change)="rerender()"
                >
              </ng-select>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="positions"
                bindLabel="name"
                bindValue="value"
                placeholder="All Positions"
                [(ngModel)]="searchParams.position"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>
          
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="twoCoOrderPfStatus"
                bindLabel="name"
                bindValue="value"
                placeholder="All Payments"
                [(ngModel)]="searchParams.two_co_order_pf_status"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                (change)="rerender()"
                >
              </ng-select>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m">
              <ng-select
                [items]="verifyOrNot"
                bindLabel="name"
                bindValue="value"
                placeholder="Verified / Unverfied"
                [(ngModel)]="searchParams.order_verified_by"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="false"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
  					        {{ item.name }}
  					    </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="httpdatewww.w3.org/2000/svg">
                <path d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z" fill="#1C212D"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="data-tables-m">
      <div class="table-responsive">
        <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
              <th>S#</th>
              <th>Order ID</th>
              <th>Timestamp</th>
              <th>Client Info</th>
              <th>Price / No. of Pages</th>
              <th>Due Date</th>
              <th>Academic Level / Subject</th>
              <th>Assigned To</th>
              <th>Writer D-D</th>
              <th>Order Status</th>
              <th>Verification</th>
              <th>Notes</th>
              <th>Action</th>
            </tr>
          </thead>

          <!-- For Support -->
          <ng-container *ngIf="leads.data && leads.data.length > 0">
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>{{ paginatePage + (indx + 1) }}</td>
                <td><a class="id" href="javascript:;" target="_blank" routerLink="/order-detail/{{ lead.id | base64 }}">{{ lead.order_id }}</a></td>
                <td>
                  <p class="time-done" *ngIf="lead.date == '0000-00-00 00:00:00'">-</p>
                  <p class="time-done" *ngIf="lead.date">{{ lead.date | date }}</p>
                  <p class="time-done">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <p>{{ lead.name }}</p>
                  <p>{{ lead.phone }}</p>
                  <p>{{ lead.email }}</p>
                </td>
                <td>
                  <div class="pos-rel">
                    <p [ngClass]="{'fullpay': !lead.half_price, 'halfpay': lead.half_price}">$ {{ lead.amount }}</p>
                    <p class="page-td">{{ lead.pages }} Pages</p>
                  </div>
                </td>
                <td>
                    <p *ngIf="lead.delivery_date == '0000-00-00 00:00:00'">-</p>
                    <ng-container *ngIf="lead.delivery_date && lead.delivery_date != '0000-00-00 00:00:00'">
                        <p>{{ lead.delivery_date | date }}</p>
                        <p>{{ lead.delivery_date | date:'shortTime' }}</p>
                    </ng-container>
                   <p class="" [ngClass]="{'time-left': !lead.dd_Invert, 'time-elapsed': lead.dd_Invert }">{{ lead.dd_TimeRemaining }}</p>
                </td>
                <td>
                  <p class="time-done">{{ lead.level | capitalize }}</p>
                  <p class="time-done">{{ lead.subject  | capitalize }}</p>
                  <!-- <p class="time-done">{{ lead.title }}</p> -->
                </td>
                <td>
                    <div class="fields-m assigned-field select-m" *ngIf="!lead.updatingAT">
                        <ng-select
                            [items]="writers"
                            placeholder="Select Writer"
                            [(ngModel)]="lead.writer_id"
                            [ngModelOptions]="{standalone: true}"
                            [searchable]="true"
                            [clearable]="false"
                            bindLabel= "name"
                            bindValue = "id"
                            (change)= "updateWriter(lead, indx)"
                            >
                            <ng-template ng-label-tmp let-item="item" *ngIf="lead.writer_id == 0">
                                Select Writer
                            </ng-template>
                            <ng-template ng-option-tmp let-item="item" let-index="index">
                                {{ item.name }}
                            </ng-template>
                        </ng-select>

                        <span class="actionUpdated" *ngIf="lead.writerUpdated">Updated</span>
                    </div>

                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingAT"></i>
                </td>
                <td>
                  <ng-container *ngIf="lead.writerDD_Col.changeDD">
                    <!-- Due date Loader -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingDD"></i>

                    <div class="fields-m assigned-field select-m datetime_N">
                      <!-- Pick Deadline If lead is Verified -->
                      <ng-container *ngIf="lead.is_verified">
                        <ng-template #popTemplate>
                          <div class="fiWrap">
                              <bs-datepicker-inline
                                  [(bsValue)]="lead.writerDD_Col.writerDD"
                                  [bsConfig]="{showWeekNumbers: false, dateInputFormat: 'YYYY-MM-DD hh:mm'}"
                                >
                              </bs-datepicker-inline>
                              <timepicker [(ngModel)]="lead.writerDD_Col.writerDD" [showMeridian]="false"></timepicker>
                          </div>
                        </ng-template>

                        <label class="agent-label set-deadline" *ngIf="!lead.updatingDD" [popover]="popTemplate" [outsideClick]="true" (onHidden)="updateWriterTime(lead, indx)" placement="auto">
                            <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z" fill="#C4CDD5"/>
                              <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#C4CDD5"/>
                              <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#C4CDD5"/>
                              <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#C4CDD5"/>
                              <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#C4CDD5"/>
                              <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#C4CDD5"/>
                              <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#C4CDD5"/>
                              <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#C4CDD5"/>
                              <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#C4CDD5"/>
                              <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#C4CDD5"/>
                              <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#C4CDD5"/>
                              <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#C4CDD5"/>
                              <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#C4CDD5"/>
                              <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#C4CDD5"/>
                              <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#C4CDD5"/>
                            </svg>

                            <span class="time-done" *ngIf="lead.writerDD_Col.writerDD">{{ lead.writerDD_Col.writerDD | customDatePipe: 'yyyy-mm-dd hh:mm' }}</span>
                            <span class="time-done" *ngIf="!lead.writerDD_Col.writerDD">Set Deadline</span>
                        </label>

                        <span class="actionUpdated" *ngIf="lead.ddUpdated">Due Date Updated</span>

                        <!-- Show Deadline Remaning time -->
                        <ng-container *ngIf="lead.writerDD_Col.timeRemaining">
                          <br *ngIf="lead.ddUpdated">
                          <p [ngClass]="{'time-left': !lead.writerDD_Col.invert, 'time-elapsed': lead.writerDD_Col.invert}">{{ lead.writerDD_Col.timeRemaining }}</p>
                        </ng-container>
                      </ng-container>

                      <!-- Set Region -->
                      <ng-select
                        *ngIf="!lead.updatingReg"
                        [items]="writersRegion"
                        placeholder="Select Region"
                        [(ngModel)]="lead.order_region"
                        [ngModelOptions]="{standalone: true}"
                        [searchable]="true"
                        [clearable]="false"
                        (change)= "updateRegion(lead, indx)"
                        [disabled]="!lead.is_verified"
                        >
                        <ng-template ng-label-tmp let-item="item" *ngIf="!lead.order_region">
                            Select Region
                        </ng-template>

                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          <span *ngIf="item == ''">
                            Select Region
                          </span>

                          <span *ngIf="item != 0">
                            {{ item }}
                          </span>
                        </ng-template>
                      </ng-select>

                      <span class="actionUpdated" *ngIf="lead.regUpdated">Region Updated</span>
                    </div>

                    <!-- Due date Loader -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingReg"></i>
                  </ng-container>

                  <p *ngIf="!lead.writerDD_Col.changeDD">
                    {{ lead.writerDD_Col['2co_Status'] }}
                  </p>
                </td>

                <td>
                  <div class="pos-rel mb-5">
                    <div class="fields-m select-m" [ngClass]="{'disposition-close': lead.position == 0, 'disposition-open': lead.position == 1,  'disposition-pending': lead.position == 2}">
                      <ng-select
                        *ngIf="!lead.updatingPos"
                        [items]="positionStatus"
                        placeholder="Order Status"
                        [(ngModel)]="lead.position"
                        [ngModelOptions]="{standalone: true}"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="value"
                        (change)="openUpdatePos(lead, indx, 'position')"
                        >
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item.name }}
                        </ng-template>
                      </ng-select>

                      <span class="actionUpdated" *ngIf="lead.posUpdatedPosition">Updated</span>
                    </div>

                    <!-- Action Loader -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingPosPosition"></i>

                    <!-- Confirmation Popup -->
                    <div class="paid-modal-m deleteModal">
                      <div class="modal fade" [id]="'pos_modal_position' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2" *ngIf="!lead.writer_id || lead.writer_id == 0">No Writer is assigned. Are you sure to change Status {{ lead.order_id }}?</h5>
                            <h5 class="modal-title" id="exampleModalLabel2" *ngIf="lead.writer_id && lead.writer_id != 0">Are you sure to change Status {{ lead.order_id }}?</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close" class="yes-btn bgRed" (click)="updatePositionAndStatus('position')">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  
                  <div class="pos-rel">
                    <div class="fields-m select-m" [ngClass]="{'disposition-close': lead.status == -1,  'disposition-pending': lead.status == 1}">
                      <ng-select
                        *ngIf="!lead.updatingPos"
                        [items]="orderStatus"
                        placeholder="Order Status"
                        [(ngModel)]="lead.status"
                        [ngModelOptions]="{standalone: true}"
                        [searchable]="false"
                        [clearable]="false"
                        bindLabel="name"
                        bindValue="value"
                        (change)="openUpdatePos(lead, indx,'status')"
                        >
                        <ng-template ng-option-tmp let-item="item" let-index="index">
                          {{ item.name }}
                        </ng-template>
                      </ng-select>

                      <span class="actionUpdated" *ngIf="lead.posUpdatedStatus">Updated</span>
                    </div>

                    <!-- Action Loader -->
                    <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingPosStatus"></i>

                    <!-- Confirmation Popup -->
                    <div class="paid-modal-m deleteModal">
                      <div class="modal fade" [id]="'pos_modal_status' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                        <div class="modal-dialog" role="document">
                          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                          </button>
                          <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel2" *ngIf="!lead.writer_id || lead.writer_id == 0">No Writer is assigned. Are you sure to change Status {{ lead.order_id }}?</h5>
                            <h5 class="modal-title" id="exampleModalLabel2" *ngIf="lead.writer_id && lead.writer_id != 0">Are you sure to change Status {{ lead.order_id }}?</h5>
                          </div>
                          <div class="modal-content">
                            <div class="modal-body">
                              <div class="action-btns">
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                                <a href="javascript:;" data-dismiss="modal" aria-label="Close" class="yes-btn bgRed" (click)="updatePositionAndStatus('status')">YES</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                <!-- <p>{{ lead.status_text }}</p> -->
              </td>
              <td>
                <div class="pos-rel popover-m tooltipWrap">
                  <div *ngIf="!lead.updatingVeri">
                    <!-- Popover Template for Verified -->
                    <ng-template #popVerified>
                        <div class="tooltipContent">
                            <ng-container *ngIf="lead.verified_by_date">
                                <p>{{ lead.verified_by }}</p>
                                <p>{{ lead.verified_by_date | date }}</p>
                                <p>{{ lead.verified_by_date | date:'shortTime' }}</p>
                            </ng-container>
                        </div>
                    </ng-template>

                    <a *ngIf="!lead.is_verified" [ngClass]="{'inactive': !lead.is_verified}" href="javascript:;" (click)="openModalVerify(lead,indx,'1')">
                      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.15584 12.4036C6.6111 11.5714 7.1148 10.7667 7.66435 9.99343C9.52238 7.43058 11.8086 5.30168 14.3422 3.42453C16.0268 2.17128 17.8082 1.05343 19.6697 0.0814906C19.8724 -0.0243497 20.0161 -0.0372017 20.2113 0.103415C20.5956 0.380111 21.0026 0.623544 21.4286 0.897973C20.4611 1.55904 19.5291 2.27041 18.6362 3.02914C15.3332 5.86566 12.612 9.20114 10.2305 12.8262C8.93947 14.7748 7.78016 16.8074 6.7603 18.9105C6.69373 19.0496 6.62261 19.1509 6.45013 19.1978C5.5423 19.4457 4.64203 19.7103 3.74025 19.9734C3.56474 20.0241 3.46109 20.0218 3.44445 19.7897C3.26894 17.2601 2.53662 14.8674 1.62879 12.52C1.17326 11.3372 0.652473 10.1805 0.0688346 9.05523C-0.0355659 8.85414 -0.0446442 8.76947 0.208792 8.69387C1.10679 8.41868 1.99873 8.12157 2.88689 7.81539C3.09494 7.73979 3.20161 7.8101 3.33022 7.95828C4.48466 9.29391 5.43668 10.7916 6.15584 12.4036Z" fill="#00A5DC"/>
                      </svg>
                    </a>
                    <a *ngIf="lead.is_verified" href="javascript:;" (click)="openModalVerify(lead,indx,'0')" [popover]="popVerified" [outsideClick]="true" placement="bottom" triggers="mouseenter:mouseleave">
                      <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.15584 12.4036C6.6111 11.5714 7.1148 10.7667 7.66435 9.99343C9.52238 7.43058 11.8086 5.30168 14.3422 3.42453C16.0268 2.17128 17.8082 1.05343 19.6697 0.0814906C19.8724 -0.0243497 20.0161 -0.0372017 20.2113 0.103415C20.5956 0.380111 21.0026 0.623544 21.4286 0.897973C20.4611 1.55904 19.5291 2.27041 18.6362 3.02914C15.3332 5.86566 12.612 9.20114 10.2305 12.8262C8.93947 14.7748 7.78016 16.8074 6.7603 18.9105C6.69373 19.0496 6.62261 19.1509 6.45013 19.1978C5.5423 19.4457 4.64203 19.7103 3.74025 19.9734C3.56474 20.0241 3.46109 20.0218 3.44445 19.7897C3.26894 17.2601 2.53662 14.8674 1.62879 12.52C1.17326 11.3372 0.652473 10.1805 0.0688346 9.05523C-0.0355659 8.85414 -0.0446442 8.76947 0.208792 8.69387C1.10679 8.41868 1.99873 8.12157 2.88689 7.81539C3.09494 7.73979 3.20161 7.8101 3.33022 7.95828C4.48466 9.29391 5.43668 10.7916 6.15584 12.4036Z" fill="#00A5DC"/>
                      </svg>
                    </a>
                  </div>

                  <!-- Action Loader -->
                  <i class="fa fa-spinner fa-spin" *ngIf="lead.updatingVeri"></i>

                  <!-- Verify Modal -->
                  <div class="paid-modal-m vrfModal">
                    <div class="modal fade" [id]="'veri_modal' + indx" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
                      <div class="modal-dialog" role="document">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                          <span aria-hidden="true">&times;</span>
                        </button>
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLabel2" *ngIf="!lead.is_verified">Are you sure you want to mark it as Verified?</h5>
                          <h5 class="modal-title" id="exampleModalLabel2" *ngIf="lead.is_verified">Are you sure you want to mark it as Unverified?</h5>
                        </div>
                        <div class="modal-content">
                          <div class="modal-body">
                            <div class="action-btns">
                              <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
                              <a href="javascript:;" class="yes-btn" [ngClass]="{'bgRed': lead.is_verified, 'bgBlue': !lead.is_verified}" (click)="verifyOrder()">YES</a>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
              <td>
                <a [ngClass]="{'iconRed': lead.view_notes}" href="javascript:;" (click)="showNotes(lead, indx)" *ngIf="!lead.gettingNotes">
                    <svg width="22" height="27" viewBox="0 0 22 27" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M21.5316 6.64509C21.4639 6.52396 21.3524 6.43557 21.2216 6.3994L17.3919 5.33954C17.4438 5.18497 17.482 5.0245 17.5063 4.86002C18.0843 4.67344 18.5664 4.27582 18.871 3.73081C19.1926 3.15553 19.278 2.48532 19.1115 1.84365C18.7679 0.519003 17.4448 -0.269856 16.1626 0.0849961C15.3382 0.313179 14.7287 0.959654 14.4894 1.74403C14.3929 1.75922 14.297 1.77889 14.2026 1.80504C13.5192 1.99415 12.9481 2.44683 12.5944 3.07964C12.4451 3.34674 12.3426 3.63257 12.2872 3.92667L5.21703 1.96989C5.08612 1.93361 4.94685 1.95265 4.82962 2.02257C4.71235 2.0925 4.62678 2.20767 4.59176 2.34278L0.0174098 19.9761C-0.0176648 20.1112 0.000714939 20.2551 0.0684135 20.3763C0.136112 20.4974 0.247616 20.5858 0.378418 20.6219L3.67032 21.533V26.4727C3.67032 26.7639 3.8989 27 4.18087 27H20.75C21.032 27 21.2606 26.7639 21.2606 26.4727V8.28667L21.5826 7.04524C21.6176 6.91019 21.5993 6.76622 21.5316 6.64509ZM16.4269 1.10378C17.1656 0.899695 17.9274 1.35374 18.1252 2.1166C18.2211 2.48617 18.1719 2.87218 17.9867 3.20346C17.8016 3.5348 17.5025 3.77179 17.1447 3.87082C16.7869 3.96975 16.4132 3.91902 16.0924 3.72775C15.7717 3.53643 15.5422 3.22762 15.4464 2.85805C15.2485 2.09519 15.6883 1.30823 16.4269 1.10378ZM13.4786 3.60704C13.6849 3.238 14.0116 2.96906 14.4033 2.84318C14.4167 2.9391 14.4352 3.03519 14.46 3.13101C14.6265 3.77268 15.0249 4.30899 15.5819 4.64117C15.8511 4.80169 16.1418 4.90442 16.4404 4.94919C16.2768 5.48703 15.8571 5.91962 15.3093 6.07123C14.4425 6.31101 13.5483 5.77787 13.316 4.88259C13.2036 4.4489 13.2613 3.99591 13.4786 3.60704ZM5.4459 3.1251L12.2985 5.0217C12.3078 5.06642 12.3182 5.11104 12.3298 5.15554C12.4074 5.45476 12.5307 5.72898 12.6894 5.97267L12.1543 6.52533C11.955 6.73126 11.955 7.06517 12.1543 7.27115C12.2541 7.37409 12.3847 7.42561 12.5153 7.42561C12.646 7.42561 12.7767 7.37409 12.8764 7.27115L13.4126 6.71728C13.843 7.01539 14.3557 7.18351 14.8887 7.18351C15.1149 7.18351 15.3449 7.15329 15.5735 7.09001C16.0788 6.95016 16.5177 6.66349 16.8517 6.2819L20.4641 7.28165L17.0118 20.5899L14.3041 19.8405C14.0317 19.7651 13.7517 19.9321 13.6787 20.2134L12.9532 23.0102L1.13587 19.7397L5.4459 3.1251ZM16.0502 21.4157L14.1264 22.5629L14.533 20.9958L16.0502 21.4157ZM20.2395 25.9453H4.69142V21.8157L13.1821 24.1656C13.2256 24.1776 13.27 24.1835 13.3142 24.1835C13.4031 24.1835 13.4912 24.1596 13.5695 24.1129L17.6281 21.6926C17.7453 21.6226 17.8309 21.5075 17.8659 21.3724L20.2394 12.2228V25.9453H20.2395Z" fill="#C4CDD5"/>
                    <path d="M6.31879 9.9475L16.4053 12.7392C16.4496 12.7514 16.494 12.7573 16.5378 12.7573C16.7632 12.7573 16.9695 12.6019 17.0306 12.3663C17.1036 12.085 16.942 11.7959 16.6696 11.7204L6.5831 8.92877C6.31062 8.85331 6.03079 9.02032 5.95778 9.30166C5.88477 9.58295 6.04641 9.87215 6.31879 9.9475Z" fill="#C4CDD5"/>
                    <path d="M5.78843 11.9944L15.875 14.786C15.9192 14.7983 15.9637 14.8042 16.0074 14.8042C16.2328 14.8042 16.4392 14.6488 16.5003 14.4132C16.5733 14.1319 16.4116 13.8427 16.1393 13.7673L6.05274 10.9756C5.78042 10.9002 5.50038 11.0672 5.42743 11.3485C5.35447 11.6298 5.51611 11.919 5.78843 11.9944Z" fill="#C4CDD5"/>
                    <path d="M8.34496 13.8039L5.52145 13.0225C5.24907 12.947 4.96909 13.114 4.89614 13.3953C4.82313 13.6766 4.98477 13.9658 5.25714 14.0412L8.08065 14.8226C8.12491 14.8348 8.16938 14.8407 8.21313 14.8407C8.43854 14.8407 8.64485 14.6853 8.70596 14.4497C8.77897 14.1684 8.61733 13.8793 8.34496 13.8039Z" fill="#C4CDD5"/>
                    <path d="M10.4323 14.4004H10.4319C10.1499 14.4004 9.92157 14.6365 9.92157 14.9277C9.92157 15.2189 10.1503 15.4551 10.4323 15.4551C10.7142 15.4551 10.9428 15.2189 10.9428 14.9277C10.9428 14.6365 10.7142 14.4004 10.4323 14.4004Z" fill="#C4CDD5"/>
                    </svg>
                </a>

                <!-- Action Loader -->
                <i class="fa fa-spinner fa-spin" *ngIf="lead.gettingNotes"></i>
              </td>
              <td>
                <div class="order-manag-options">
                  <a href="javascript:;" class="edit" target="_blank" routerLink="/modify-order/{{ lead.id | base64 }}">
                    <svg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M17.7051 0.805083C16.6298 -0.268361 14.8884 -0.268361 13.8131 0.805083L12.8388 1.78468L2.46786 12.1501L2.44582 12.1723C2.44048 12.1777 2.44048 12.1833 2.4348 12.1833C2.42378 12.1999 2.40725 12.2162 2.3964 12.2328C2.3964 12.2383 2.39072 12.2383 2.39072 12.2438C2.3797 12.2603 2.37436 12.2713 2.36317 12.2879C2.35783 12.2934 2.35783 12.2987 2.35232 12.3044C2.34681 12.3209 2.3413 12.3319 2.33562 12.3485C2.33562 12.3538 2.33028 12.3538 2.33028 12.3595L0.0292825 19.2789C-0.0382167 19.4758 0.0130965 19.694 0.161354 19.8402C0.26553 19.943 0.406038 20.0005 0.552229 20C0.61198 19.999 0.671214 19.9897 0.728381 19.9724L7.6424 17.6659C7.64774 17.6659 7.64774 17.6659 7.65342 17.6606C7.67081 17.6554 7.68751 17.648 7.70284 17.6384C7.70714 17.6379 7.71093 17.636 7.71403 17.633C7.73039 17.622 7.75243 17.6108 7.76896 17.5998C7.78532 17.589 7.80202 17.5724 7.81855 17.5614C7.82406 17.5557 7.8294 17.5557 7.8294 17.5504C7.83508 17.5449 7.8461 17.5395 7.85161 17.5284L19.1968 6.18315C20.2703 5.10781 20.2703 3.36644 19.1968 2.29127L17.7051 0.805083ZM7.46625 16.3723L3.63498 12.5412L13.2242 2.95197L17.0554 6.78307L7.46625 16.3723ZM3.09533 13.5595L6.4424 16.9064L1.41646 18.5798L3.09533 13.5595ZM18.4207 5.41242L17.8372 6.00149L14.0057 2.17005L14.595 1.58115C15.2395 0.937154 16.2842 0.937154 16.9289 1.58115L18.4261 3.07836C19.0658 3.7258 19.0634 4.76808 18.4207 5.41242Z" fill="#F07527"/>
                    </svg>
                  </a>
                  <a href="javascript:;">
                    <svg width="19" height="25" viewBox="0 0 19 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M15.1998 10.577H3.7998V11.5385H15.1998V10.577Z" fill="#F07527"/>
                      <path d="M15.1998 13.4616H3.7998V14.4231H15.1998V13.4616Z" fill="#F07527"/>
                      <path d="M15.1998 16.3462H3.7998V17.3078H15.1998V16.3462Z" fill="#F07527"/>
                      <path d="M9.4998 19.2309H3.7998V20.1924H9.4998V19.2309Z" fill="#F07527"/>
                      <path d="M9.51426 3.60579C9.90776 3.60579 10.2268 3.28291 10.2268 2.88463C10.2268 2.48634 9.90776 2.16347 9.51426 2.16347C9.12075 2.16347 8.80176 2.48634 8.80176 2.88463C8.80176 3.28291 9.12075 3.60579 9.51426 3.60579Z" fill="#F07527"/>
                      <path d="M18.9999 5.7692C18.9999 4.70711 18.1493 3.84611 17.1 3.84611H14.4623C14.1105 3.4505 13.6585 3.14779 13.1392 2.99659C12.7018 2.8693 12.3651 2.52856 12.2393 2.08583C11.897 0.881254 10.8002 0 9.49994 0C8.19975 0 7.10297 0.881194 6.76073 2.08571C6.63474 2.52898 6.29725 2.8693 5.8593 2.99707C5.3406 3.14839 4.88906 3.4508 4.5375 3.84611H1.9C0.850606 3.84611 0 4.70711 0 5.7692V23.0769C0 24.139 0.850606 25 1.9 25C6.26204 25 11.6231 25 17.1 25C18.1494 25 19 24.139 19 23.0769C19 17.6154 18.9999 12.3856 18.9999 5.7692ZM4.75006 5.75369C4.75659 4.90838 5.32089 4.15477 6.12239 3.92099C6.87705 3.70092 7.45697 3.11414 7.67368 2.35151C7.90626 1.53306 8.65723 0.961543 9.49994 0.961543C10.3427 0.961543 11.0937 1.53306 11.3262 2.35157C11.543 3.11468 12.1226 3.70128 12.8765 3.92069C13.6851 4.15609 14.2499 4.91625 14.2499 5.76914V6.73068H4.75006V5.75369ZM17.1 24.0385C12.0261 24.0385 6.96053 24.0385 1.9 24.0385C1.37613 24.0385 0.95 23.6071 0.95 23.0769V5.7692C0.95 5.23903 1.37613 4.80766 1.9 4.80766H3.96281C3.86009 5.10165 3.80261 5.41721 3.80012 5.74618V7.69229H15.2V5.7692C15.2 5.43176 15.1411 5.10868 15.0359 4.80766H17.1C17.6238 4.80766 18.0499 5.23903 18.0499 5.7692C18.0499 8.51819 18.0499 21.4095 18.0501 23.0769C18.05 23.6071 17.6239 24.0385 17.1 24.0385Z" fill="#F07527"/>
                    </svg>
                  </a>
                </div>
              </td>
          </tr>
        </tbody>
        </ng-container>
        </table>
      </div>
    </div>
  </div>
</section>

<!-- Send Email to Writers Modal -->
<div class="paid-modal-m">
  <div class="modal fade" id="sendEmailModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel2" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel2">Are you sure to send email to all writers?</h5>
      </div>
      <div class="modal-content">
        <div class="modal-body">
          <div class="action-btns">
            <a href="javascript:;" data-dismiss="modal" aria-label="Close">NO</a>
            <a href="javascript:;" class="yes-btn bgBlue" (click)="sendEmailsToWriters()">YES</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Notes Modal -->
<div class="notesModal mainModal">
  <div class="modal fade" id="notesModal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
      <div class="modal-header">
        <h5 class="modal-title">Add Notes</h5>
      </div>
      <div class="modal-content">
        <div class="modal-body">
            <form action="">
                <div class="formItem static shadowed w-100">
                    <textarea [(ngModel)]="notes" [ngModelOptions]="{standalone: true}" placeholder="write here to add notes"></textarea>
                </div>
                <div class="formBtns text-right">
                    <button class="pBtn" (click)="addNotes()" [disabled]="addingNote">
                      <i class="fa fa-spinner fa-spin" *ngIf="addingNote"></i>
                      Add
                    </button>
                </div>
            </form>
            <h5 class="modal-title" *ngIf="comments && comments.data && comments.data.length > 0">All Notes</h5>
            <ul class="allNotes comment-box" *ngIf="comments">
                <li *ngFor="let comment of comments.data">
                  <label *ngIf="agents">{{ agentSearch(comment.user_id, all_users) }}</label>
                  <p class="p-0 text-left">{{ comment.notes }}</p>
                  <span class="date-comment">{{ comment.date | customDatePipe: 'dateTime' }}</span>
                </li>
            </ul>
        </div>
      </div>
    </div>
  </div>
</div>
